import CommonService from '../../../../services/commonService';
import aeroquintaIcons from './aeroquintaIcons';
import andimarIcons from './andimarIcons';
import arzolaIcons from './arzolaIcons';
import bahiaazulIcons from './bahiaazulIcons';
import biagginiIcons from './biagginiIcons';
import busesahumadaIcons from './busesahumadaIcons';
import busesbarriaIcons from './busesbarriaIcons';
import busesjmIcons from './busesjmIcons';
import centralTourIcons from './centralTourIcons';
import centropuertoIcons from './centropuertoIcons';
import chilebusIcons from './chilebusIcons';
import combarbalaIcons from './combarbalaIcons ';
import cormarbusIcons from './cormarbusIcons';
import erbucIcons from './erbucIcons';
import expresoNatroIcons from './expresoNatroIcons';
import expresosantacruz from './expresoSantaCruzIcons';
import fernandezIcons from './fernandezIcons';
import ivergramaIcons from './ivergramaIcons';
import jeldresIcons from './jeldresIcons';
import jetsurIcons from './jetsurIcons';
import kennybusIcons from './kennybusIcons';
import lafitIcons from './lafitIcons';
import lineaazulIcons from './lineaazulIcons';
import liquineIcons from './liquineIcons';
import navegadoresIcons from './navegadoresIcons';
import norteIcons from './norteIcons';
import pullmanSanAndreasIcons from './pullmanSanAndreasIcons';
import pullmandelsurIcons from './pullmandelsurIcons';
import sanantonioIcons from './sanantonioIcons';
import santajuanaIcons from './santajuanaIcons';
import santamariaIcons from './santamariaIcons';
import santarosaIcons from './santarosaIcons';
import saopauloIcons from './saopauloIcons';
import serenamarIcons from './serenamarIcons';
import tacohaIcons from './tacohaIcons';
import tarapacaIcons from './tarapacaIcons';
import teupalIcons from './tepualIcons';
import thaebusIcons from './thaebusIcons';
import torresIcons from './torresIcons';
import travelturIcons from './travelturIcons';
import trrassIcons from './trrassIcons';
import viaturIcons from './viaturIcons';

const footerKuposLogo = '/assets/common/Footer-kuposLogo.svg';

const icons = {
	tepual: teupalIcons,
	saopaulo: saopauloIcons,
	chilebus: chilebusIcons,
	pullmandelsur: pullmandelsurIcons,
	viatur: viaturIcons,
	kennybus: kennybusIcons,
	santarosa: santarosaIcons,
	tarapaca: tarapacaIcons,
	andimar: andimarIcons,
	expressonorte: expresoNatroIcons,
	ivergrama: ivergramaIcons,
	busnorte: norteIcons,
	bahiaazul: bahiaazulIcons,
	pullmansanandres: pullmanSanAndreasIcons,
	fernandez: fernandezIcons,
	erbuc: erbucIcons,
	cormarbus: cormarbusIcons,
	serenamar: serenamarIcons,
	jetsur: jetsurIcons,
	busesjm: busesjmIcons,
	barriaghisoni: busesbarriaIcons,
	combarbala: combarbalaIcons,
	trrass: trrassIcons,
	expresosantacruz: expresosantacruz,
	busesahumada: busesahumadaIcons,
	sanantonio: sanantonioIcons,
	traveltur: travelturIcons,
	thaebus: thaebusIcons,
	centraltour: centralTourIcons,
	liquine: liquineIcons,
	tacoha: tacohaIcons,
	centropuerto: centropuertoIcons,
	santamaria: santamariaIcons,
	biaggini: biagginiIcons,
	santajuana: santajuanaIcons,
	norteicons: norteIcons,
	aeroquinta: aeroquintaIcons,
	lineaazul: lineaazulIcons,
	jeldres: jeldresIcons,
	basetorres: torresIcons,
	arzola: arzolaIcons,
	losnavegadores: navegadoresIcons,
	buseslafit: lafitIcons,
};


const getIcons = (type, operator) => {
	operator = operator || CommonService.getLocal('op') || {};
	const name = operator && operator.operator_name ? operator.operator_name : '';

	const data = icons[name] ? icons[name] : [];
	if (type === 'kuposLogo') {
		return footerKuposLogo;
	} else {
		const showIcon = data.find(val => val.name === type);
		return showIcon && showIcon.icon ? showIcon.icon : '';
	}
};

export default getIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/getIcons.js